import configs from '@/configs';
import {request_header, request_list} from '@/commons/hpod';

export default {
    getPayOrderList(cb, $http, param, token) {
        request_list('pay_order', cb, $http, param, token)
    },
    getPayOrderDetail(cb, $http, customerId, token) {
        const req = {
            headers: request_header(token)
        };
        $http.get(`${process.env.VUE_APP_ENDPOINT}/admin/api/pay_order/${customerId}`, req).then(function (res) {
            setTimeout(() => cb(res.data), 100);
        });
    },
    updatePayOrder(cb, $http, payload, token) {
        const header = {
            headers: request_header(token)
        };
        $http.post(`${process.env.VUE_APP_ENDPOINT}/admin/api/pay_order/${payload.customer_id}`, payload, header).then(function (res) {
            setTimeout(() => cb(res.data), 100);
        });
    }
}
